module.exports.currencyFormatter = (value)=>{
    return( new Intl.NumberFormat('de-DE', 
    { style: 'currency', currency: 'EUR' }
  ).format(value))
} 

module.exports.openInNewTab = (url) => {
  const newWindow = window.open(url, '_blank', 'noopener,noreferrer')
  if (newWindow) newWindow.opener = null
}